import "./path0.6aa9045e.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire383b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire383b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");

// Portfolio data - customize with your actual projects
const $a58458f679f1a4b2$var$projects = [
    {
        id: 1,
        title: "Energy Markets Dashboard",
        description: "Interactive visualization of ISO New England electricity market data with real-time price tracking, demand forecasting displays, and historical trend analysis using D3.js.",
        tags: [
            "React",
            "D3.js",
            "Energy Systems",
            "Data Visualization"
        ],
        github: "https://github.com/ZevPinker/EnergyMarketsDashboard",
        category: "software",
        featured: true
    },
    {
        id: 2,
        title: "U.S. Offshore Wind Development Policy Review",
        description: "An analysis of the stages of domestic offshore wind energy development between 2024 and 2025 (post OBBBA) based on the National Renewable Energy Laboratory annual report.",
        tags: [
            "Renewables",
            "Offshore Wind",
            "Clean Energy",
            "Policy",
            "Market"
        ],
        publication: "https://cleanenergyforum.yale.edu/2025/07/30/us-offshore-wind-development-policy-review",
        category: "research",
        featured: true
    },
    {
        id: 3,
        title: "Optimal Power Flow Research",
        description: "Capstone research exploring computational approaches to nonconvex OPF problems, investigating convex relaxations and learning-augmented optimization methods for power systems.",
        tags: [
            "in-progress",
            "Optimization",
            "Power Systems",
            "Research",
            "Python"
        ],
        category: "research",
        featured: true
    },
    {
        id: 4,
        title: "Economic Dispatch Optimizer",
        description: "Implementation of analytical and numerical optimization methods for economic dispatch, including dual gradient ascent, Newton's method, and BFGS with transmission loss modeling.",
        tags: [
            "Python",
            "Optimization",
            "Energy",
            "Numerical Methods"
        ],
        publication: "https://available-act-9fb.notion.site/Applied-Planning-and-Optimization-Final-Project-2cdf2c8889d980bbb4f9d687128dc5ca",
        category: "software",
        featured: false
    },
    {
        id: 5,
        title: "CT Demand Response Analysis",
        description: "IAD framework analysis of Connecticut's demand response aggregation markets, examining ISO-NE market structures and curtailment service provider regulations.",
        tags: [
            "Policy Analysis",
            "Energy Markets",
            "Research"
        ],
        category: "research",
        featured: false
    }
];
const $a58458f679f1a4b2$var$categories = [
    {
        id: "all",
        label: "All Work"
    },
    {
        id: "software",
        label: "Software"
    },
    {
        id: "research",
        label: "Research"
    }
];
// Simple icon components
const $a58458f679f1a4b2$var$GitHubIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"
        })
    });
const $a58458f679f1a4b2$var$ExternalIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "15 3 21 3 21 9"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "10",
                y1: "14",
                x2: "21",
                y2: "3"
            })
        ]
    });
const $a58458f679f1a4b2$var$DocumentIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("polyline", {
                points: "14 2 14 8 20 8"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "16",
                y1: "13",
                x2: "8",
                y2: "13"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("line", {
                x1: "16",
                y1: "17",
                x2: "8",
                y2: "17"
            })
        ]
    });
function $a58458f679f1a4b2$var$PortfolioApp() {
    const [activeCategory, setActiveCategory] = (0, $acw62.useState)("all");
    const [hoveredProject, setHoveredProject] = (0, $acw62.useState)(null);
    const filteredProjects = activeCategory === "all" ? $a58458f679f1a4b2$var$projects : $a58458f679f1a4b2$var$projects.filter((p)=>p.category === activeCategory);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "portfolio-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "background-texture"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("header", {
                className: "portfolio-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "portfolio-title",
                        children: "Technical Portfolio"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "portfolio-subtitle",
                        children: "Selected work in software engineering, energy systems, and computational research"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
                className: "filters",
                children: $a58458f679f1a4b2$var$categories.map((cat)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: ()=>setActiveCategory(cat.id),
                        className: `filter-button ${activeCategory === cat.id ? 'filter-button-active' : ''}`,
                        children: cat.label
                    }, cat.id))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                className: "projects-grid",
                children: filteredProjects.map((project)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("article", {
                        className: `project-card ${project.featured ? 'card-featured' : ''} ${hoveredProject === project.id ? 'card-hovered' : ''}`,
                        onMouseEnter: ()=>setHoveredProject(project.id),
                        onMouseLeave: ()=>setHoveredProject(null),
                        children: [
                            project.featured && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "featured-badge",
                                children: "Featured"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "card-content",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "category-indicator",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: `category-dot ${project.category === 'software' ? 'dot-software' : 'dot-research'}`
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "category-label",
                                                children: project.category === 'software' ? 'Software' : 'Research'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                        className: "card-title",
                                        children: project.title
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "card-description",
                                        children: project.description
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "tags",
                                        children: project.tags.map((tag)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "tag",
                                                children: tag
                                            }, tag))
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "links",
                                        children: [
                                            project.github && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                href: project.github,
                                                className: "project-link",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($a58458f679f1a4b2$var$GitHubIcon, {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: "Code"
                                                    })
                                                ]
                                            }),
                                            project.live && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                href: project.live,
                                                className: "project-link",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($a58458f679f1a4b2$var$ExternalIcon, {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: "Live"
                                                    })
                                                ]
                                            }),
                                            project.publication && /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                                                href: project.publication,
                                                className: "project-link",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)($a58458f679f1a4b2$var$DocumentIcon, {}),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        children: "Paper"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "corner-accent"
                            })
                        ]
                    }, project.id))
            })
        ]
    });
}
const $a58458f679f1a4b2$var$root = (0, $aRPiL.createRoot)(document.getElementById('root'));
$a58458f679f1a4b2$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)($a58458f679f1a4b2$var$PortfolioApp, {}));
var $a58458f679f1a4b2$export$2e2bcd8739ae039 = $a58458f679f1a4b2$var$PortfolioApp;


//# sourceMappingURL=portfolio.637fe694.js.map
